/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';
import { LoadingSpinner } from '../../../components/Loading/LoadingSpinner';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * PG사 콜백 페이지
 * @description 결제 결과를 처리하고, 완료 페이지로 이동함
 */
const PurchaseStaging = () => {
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const res = query.get('res') as string;
  const mst_id = query.get('mst_id') as string;

  useEffect(() => {
    // 결제 결과 전달
    const success = res === 'y' ? true : false;
    if (success) {
      navigate(`/purchase/complete/${mst_id}`);
    } else {
      // FIXME: res=n 만 오고 나머지가 안옴,,, code, message, orderId 필요함
      const errorMessage = '결제에 실패했습니다.';
      navigate(
        `/commerce/purchase/fail?code=PAYMENT_FAILED&message=결제에 실패했습니다.`,
      );
      const templateId = localStorage.getItem('templateId');
      navigate('/purchase', { state: { purchaseId: templateId } });
      localStorage.removeItem('templateId');
    }
  }, [res]);

  return (
    <div className="fixed left-0 top-0 flex h-full w-full justify-center bg-gray2 opacity-80">
      <div className="mx-auto flex w-fit flex-col items-center justify-center gap-5 py-10">
        <LoadingSpinner />
        <div className="text-center text-sm text-gray-800">
          결제 진행중입니다
        </div>
        <div className="text-center text-xs text-gray-600">처리중</div>
      </div>
    </div>
  );
};

export default PurchaseStaging;
